import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import './localization';
import App from 'App';
import './socket';
import React from 'react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
